import { ArticleFields } from '../../../firebase/document-field.enums';
import { FilterModel } from './filter.model';
import { FilterType } from './filter.type';

export const ARTICLE_LIST_FILTERS: FilterModel[] = [
  {
    fieldName: ArticleFields.title,
    label: 'articles.fields.title',
    placeholder: 'articles.fields.title',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: ArticleFields.topic,
    label: 'articles.fields.topic',
    placeholder: 'articles.fields.topic',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: ArticleFields.section,
    label: 'articles.fields.section',
    placeholder: 'articles.fields.section',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: ArticleFields.color,
    label: 'articles.fields.color',
    placeholder: 'articles.fields.color',
    type: FilterType.text,
    value: '',
  },
];
